/**
 * Provides fade-slider behavior for ACF full-width sliders.
 */
class FadeSlider {
    constructor() {
        this.sliders = new Map();
        this.init();
    }

    init() {
        const sliders = document.querySelectorAll('.image-block--slider');
        
        sliders.forEach(slider => {
            if (slider.dataset.isSlider === 'true') {
                this.setupSlider(slider);
            }
        });
    }

    setupSlider(slider) {
        const slides = slider.querySelectorAll('.fade-slide');
        if (slides.length < 2) return;

        let currentIndex = 0;
        
        const transition = () => {
            slides[currentIndex].classList.remove('active');
            currentIndex = (currentIndex + 1) % slides.length;
            slides[currentIndex].classList.add('active');
        };

        const interval = setInterval(transition, 3000);
        
        // Store interval for cleanup if needed
        this.sliders.set(slider.id, interval);
    }

    // Cleanup method
    destroy() {
        this.sliders.forEach(interval => {
            clearInterval(interval);
        });
        this.sliders.clear();
    }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
    window.fadeSlider = new FadeSlider();
});
